import styled from 'styled-components'
import {
  Button,
  Title as DefaultTitle,
  Typography,
} from '~components'

import AnttFront from '~assets/images/anttFront.jpg'
import AnttBack from '~assets/images/anttBack.jpg'

export const Title = styled(DefaultTitle)`
  margin-bottom: 28px;
`

export const LinkButton = styled(Button).attrs({ type: 'button' })`
  margin-top: ${({ theme }) => theme.spacing.km1};
  width: 100%;
`

export const ModalChildSubtitle = styled(Typography).attrs({ as: 'p' })`
  font-weight: ${({ theme }) => theme.font.weight.semibold};
  font-size: ${({ theme }) => theme.font.size.m3};
  color: #363636;
`

export const ModalChildMessage = styled(Typography).attrs({ as: 'p' })`
  font-size: ${({ theme }) => theme.font.size.m3};
  color: ${({ theme }) => theme.neutral.text.default};
`

export const AnttCardFront = styled.img.attrs({
  src: AnttFront,
})`
  flex: 1;
  width: 100%;
  min-width: 0px;
  margin-left: auto;
`

export const AnttCardBack = styled.img.attrs({
  src: AnttBack,
})`
  flex: 1;
  width: 100%;
  min-width: 0px;
  margin-right: auto;
`

export const AnttCard = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing.km3};
`

export const AnttCardOr = styled.div`
  font-size: ${({ theme }) => theme.font.size.m3};
  color: #363636;
  width: 30px;
  text-align: center;
`
